<template>
    <section>
        Aqui
    </section>
</template>

<script>

export default {
  name: "specialist",
  components: {
  },
  data() {
    return {
    };
  },
  mounted() {

  }
}
</script>

<style lang="scss" scoped>

</style>
